import { isToday } from './utils'

export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// 金額顯示：$ + 千分位 + 固定兩位小數，例如 682400 -> $682,400.00
export const formatCurrency = (value) => {
  const num = Number(value)
  if (value === null || value === undefined || value === '' || Number.isNaN(num)) return '$0.00'

  const formatted = Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  return num < 0 ? `-$${formatted}` : `$${formatted}`
}

export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })
  return capitalizedArray.join(' ')
}

export const avatarText = value => {
  if (!value) return ''
  const nameArray = value.split(' ')
  return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')

/**
 * 清理檔案名稱中的特殊字符，確保檔案名稱安全
 * @param {String} filename 原始檔案名稱
 * @returns {String} 清理後的檔案名稱
 */
export const sanitizeFilename = (filename) => {
  if (!filename) return ''

  return filename
    // 替換不安全的字符為安全字符
    .replace(/[<>:"/\\|?*]/g, '_') // 將 Windows 不允許的字符替換為下劃線
    .replace(/[\x00-\x1f\x80-\x9f]/g, '') // 移除控制字符
    .replace(/^\.+/, '') // 移除開頭的點
    .replace(/\.+$/, '') // 移除結尾的點
    .replace(/\s+/g, ' ') // 將多個空格替換為單個空格
    .replace(/_{2,}/g, '_') // 將多個連續下劃線替換為單個下劃線
    .trim() // 移除首尾空格
    .substring(0, 255) // 限制長度為 255 字符
}
